import { render, staticRenderFns } from "./independent-study.vue?vue&type=template&id=0597a772&scoped=true&"
import script from "./independent-study.ts?vue&type=script&lang=ts&"
export * from "./independent-study.ts?vue&type=script&lang=ts&"
import style0 from "./independent-study.scss?vue&type=style&index=0&id=0597a772&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0597a772",
  null
  
)

export default component.exports